export default __webpack_public_path__ + "static/media/steering-wheel-icon.e3bb3d2a.svg";